<template>
  <div class="content-box finacial-list-page">
    <div class="page-title">财务分析</div>
    <div class="finacial-search search">
      <div class="finacial-search__type yjh-btn-group">
        <Button :class="{'ivu-btn-primary': type==='day'}" @click="gotoType('day')">日账单</Button>
        <Button :class="{'ivu-btn-primary': type==='month'}" @click="gotoType('month')">月账单</Button>
      </div>
      <div class="finacial-search__date search-item">
        <label class="search-title">日期</label>
        <DatePicker
          v-model="searchDate"
          :type="searchDateType"
          :editable="false"
          :clearable="false"
          placeholder="请选择"
          style="width: 156px"
          :options="monthOpts"
          @on-change="getData"
        ></DatePicker>
      </div>
    </div>
    <div class="page-table-box yjh-finacial-list">
      <pageTable
        ref="finacialTable"
        class="yjh-finacial-flow"
        :loading="tableLoading"
        :col="col"
        :data="tableData"
        :total="total"
        :pageSize="pageSize"
        :pageIndex="page"
        :showPage="false"
        :isVerticalResize="false"
        :showVerticalBorder="true"
        :showHorizontalBorder="true"
        :showTrBack="false"
        :titleIconMouseEnter="titleIconMouseEnter"
        :titleIconMouseLeave="titleIconMouseLeave"
        :cell-merge="cellMerge"
      ></pageTable>
      <div class="finacial-title__tips" v-if="showTip" :style="{left: titleTipLeft, top: titleTipTop}">
        <div class="inacial-tip__title">{{titleTip}}</div>
        <div class="inacial-tip__content">{{titleContent}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import _ from 'underscore'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'

import { finacialList } from '@/api/report'

import { dateObjToStr } from '@/utils/common'
export default {
  components: { pageTable },
  mixins: [pageTableMixin],
  data() {
    return {
      footer: [['当日合计', '', '', '', '', '', '']],
      // 搜索日期
      searchDate: '',
      monthOpts: {
        disabledDate(date) {
          var now = new Date()
          return date.getFullYear() < 2018 || date.getFullYear() > now.getFullYear() || (date.getFullYear() === now.getFullYear() && date.getMonth() > now.getMonth())
        }
      },
      // 表头提示
      showTip: false,
      titleTip: '',
      titleContent: '',
      titleTipLeft: '',
      titleTipTop: '',
      tipsMap: {
        invest_money: { title: '充值金额', content: '充值到药聚汇结算账户金额' },
        pay_money: { title: '付款金额', content: '付款金额（不含同户名互转，减去退款金额）' },
        receive_money: { title: '收款金额', content: '收款金额（不含同户名互转）' },
        withdraw_money: { title: '提现金额', content: '提现成功金额' }
      }
    }
  },
  computed: {
    type() {
      return this.$route.params.type || 'day'
    },
    searchDateType() {
      if (this.type === 'month') {
        return 'year'
      } else {
        return 'month'
      }
    },
    col() {
      const tmp = [
        { field: 'cl_date', title: '日期' },
        { field: 'type', title: '科目' },
        { field: 'invest_money', title: '充值金额', helpIcon: 'iconfont iconwenhao' },
        { field: 'pay_money', title: '付款金额', helpIcon: 'iconfont iconwenhao' },
        { field: 'receive_money', title: '收款金额', helpIcon: 'iconfont iconwenhao' },
        { field: 'withdraw_money', title: '提现金额', helpIcon: 'iconfont iconwenhao' },
        { field: 'operation', title: '操作', componentName: 'finacialOpe' }
      ]
      return tmp.map(item => {
        item.isResize = true
        item.titleAlign = 'left'
        item.columnAlign = 'left'
        item.width = 120
        item.overflowTitle = true
        return item
      })
    },
    reqDate() {
      const fullDate = dateObjToStr(this.searchDate).replace(/\-/g, '').split(' ')[0]
      if (this.type === 'month') {
        return fullDate.substring(0, 4)
      } else {
        return fullDate.substring(0, 6)
      }
    }
  },
  mounted() {
    this.$store.commit('SET_RETURN_FULLURL', '')
  },
  methods: {
    // 表头帮助图标
    titleIconMouseEnter(e, field) {
      this.titleTipLeft = e.target.getBoundingClientRect().x + 'px'
      this.titleTipTop = e.target.getBoundingClientRect().y + e.target.getBoundingClientRect().height + 4 + 'px'
      this.showTip = true
      this.titleTip = this.tipsMap[field].title
      this.titleContent = (this.type === 'month' ? '当月' : '当日') + this.tipsMap[field].content
    },
    titleIconMouseLeave(e, field) {
      this.showTip = false
      this.titleTipLeft = '100000px'
      this.titleTipTop = '100000px'
      this.titleTip = ''
      this.titleContent = ''
    },
    // 合计合并单元格
    cellMerge(rowIndex, rowData, field) {
      if (field === 'cl_date' && rowData[field] === '合计') {
        const text = this.type === 'day' ? '本月合计' : '本年合计'
        return {
          colSpan: 2,
          rowSpan: 1,
          content: `<span class="finacial-table-sum">${text}</span>`
        }
      }
    },
    // 切日月
    gotoType(type) {
      this.tableLoading = true
      if (type === this.type) {
        return
      }
      this.$router.push({
        name: this.$route.name,
        params: { type: type }
      })
      this.getData()
    },
    // 切页面初始化
    initPage() {
      this.searchDate = new Date()
      this.getData()
    },
    // 获取数据
    getData: _.debounce(function() {
      this.tableLoading = true
      finacialList(this.type, this.reqDate).then(res => {
        setTimeout(() => { this.tableLoading = false }, 100)
        if (res.code !== 0) {
          this.$Message.info(res.msg)
          return
        }
        this.tableData = res.result.list
        this.tableData.push({
          cl_date: '合计',
          type: '',
          invest_money: res.result.summary.invest_money,
          pay_money: res.result.summary.pay_money,
          receive_money: res.result.summary.receive_money,
          withdraw_money: res.result.summary.withdraw_money
        })
        // 合并单元格和加高
        this.$nextTick(() => {
          const $table = this.$refs.finacialTable.$el.querySelector('.v-table-views')
          const $tbody = this.$refs.finacialTable.$el.querySelector('.v-table-body')

          setTimeout(() => {
            $table.style.height = $table.offsetHeight + 18 + 'px'
            $tbody.style.height = $tbody.offsetHeight + 18 + 'px'
          }, 100)
        })
      })
    }, 300)
  }
}
Vue.component('finacialOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    goDetail() {
      this.$router.push({
        name: 'finacialTradeFlowDetail',
        params: {
          type: this.$route.params.type,
          date: this.rowData.cl_date
        }
      })
    }
  },
  render: function(h) {
    if (this.rowData.cl_date.includes('合计')) {
      return ''
    } else {
      return h('div', {
        class: {
          operate: true
        }
      }, [h('a', {
        on: {
          click: this.goDetail
        }
      }, '查看')])
    }
  }
})
</script>
<style lang="scss" scoped="">
  @import "@/styles/color.scss";
  .finacial-search {
    margin-bottom: 0;
    & > * {
      display: inline-block;
      margin-bottom: 20px;
      line-height: 28px;
    }
  }
  .finacial-search__type {
    margin-right: 30px;
  }
  .finacial-title__tips {
    position: fixed;
    background: #fff;
    max-width: 200px;
    box-shadow: 0px 2px 6px 0px rgba(135,150,176,0.26);
    padding: 10px;
  }
  .inacial-tip__title {
    margin-bottom: 10px;
    font-weight: bold;
  }
  .inacial-tip__content {
    color: $fontLightBlack;
    line-height: 18px;
  }
</style>
<style lang="scss">
  @import "@/styles/color.scss";
  .yjh-finacial-flow {
    .v-table-header:before {
      height: 50px;
    }
    .v-table-body tr:last-child {
      background: $tableTrLastColor !important;
      height: 50px;
      .v-table-body-cell {
        line-height: 50px !important;
        height: 50px !important;
        color: $fontBlack;
        font-weight: bold;
        font-size: 14px;
      }
    }
  }
  .finacial-list-page .page-table-box .v-table-header-inner tr td {
    border-bottom: 0;
  }
</style>
